import externalClientFilters from '@/app/dashboard/external-clients/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ExternalClientConfig,
  type ExternalClient,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
export const ExternalClientItem: RelationFieldProps<ExternalClient> = {
  nested: getRelationFieldNames(ExternalClientConfig),
  filters: externalClientFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <span className='font-medium'>
          {item.orgNo ?? 'Inget organisationsnummer angivet'}
        </span>
        {!isRelationField && <Dot />}
        <span>{item?.customId ?? 'Inget objekts-id angivet'}</span>
      </div>
    ),
  }),
};
